<template>
  <div>
    <!-- modal del Lector -->
      <v-dialog v-model="estadoComp" persistent scrollable max-width="100%">
        <v-card>
          <v-card-title class="modal_title py-5 mb-2">
              <v-row class="d-flex justify-end py-0"> 
                  <v-btn fab dark x-small class="btn_style3" @click="Close()"><v-icon dark>fa-times</v-icon></v-btn>
              </v-row>
          </v-card-title> 

          <v-divider></v-divider>

          <v-card-text class="justify-center">
            <v-img cover :src="parametros.fileLink"></v-img>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>
  import { mapMutations } from 'vuex';
  
  export default {
    name: 'LectorImageComp',
    props: {
      parametros: {
        type: Object,
        default() {
          return {};
        }
      },
      estadoComp:{
        type: Boolean,
        default() {
          return true;
        }
      },
    },

    mounted() {
      this.LoadMain();
    },

    methods: {
      ...mapMutations('mensajeSis', ['setEnviarMens']),
      
      Close(){
        this.$emit('close');
      },

      LoadMain() {

      }
    },

    watch: {
      // cada vez que la pregunta cambie, esta función será ejecutada
      estadoComp() {
        if(this.estadoComp){
          this.LoadMain()                    
        }      
      }
    },
  }
</script>